import { Plus } from "lucide-react";
import { useState } from "react";

import NoDataIcon from "../../../../src/assets/svg/EmptyTableIcon";
import CreateFraudElementsModal from "./createFraudElementModal";

export default function EmptyFraudElementsState() {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <>
      <div className="flex h-[574px] items-center justify-center rounded-b-[14px] rounded-t-none border border-[#E5E5E5] bg-white px-6 py-4">
        <div className="flex w-[480px] flex-col items-center gap-6 p-6">
          <NoDataIcon />

          <div className="flex w-[304px] flex-col items-center gap-2">
            <h3 className="text-base font-semibold leading-6 text-[#0A0A0A] text-center">
              No fraud elements created yet
            </h3>

            <p className="text-sm leading-5 text-[#737373] text-center">
              Create the first fraud element for this party to capture fraud
              details
            </p>
          </div>

          <button
            type="button"
            onClick={() => setIsCreateModalOpen(true)}
            className="flex h-9 items-center justify-center gap-2 rounded-[8px] bg-gradient-to-b from-[#788AF7] to-[#3551F3] px-4 py-2 text-sm font-medium leading-5 text-[#FEF2F2] shadow-[0_1px_2px_rgba(0,0,0,0.05)] transition-all hover:opacity-90"
          >
            <Plus className="h-4 w-4 text-[#FEF2F2]" />
            Create Fraud Element
          </button>
        </div>
      </div>

      {isCreateModalOpen && (
        <CreateFraudElementsModal
          onClose={() => setIsCreateModalOpen(false)}
        />
      )}
    </>
  );
}